import { deepMerge } from '@/utils';
import { getCampaignConfig } from '@/views/fusion/investment/intelligence-create/model/form';

export default (s) => {
  const basic_form_fields = {
    base_form: {
      config: getCampaignConfig([
        'campaign_name',
      ]),
    },
    schedule_form: {
      title: '广告排期',
      config: getCampaignConfig([
        'schedule_type',
        'delivery_date',
        'time_period_type',
        'schedule_time',
        'time_period',
      ]),
    },
    budget_and_bid_form: {
      title: '广告预算与出价',
      config: getCampaignConfig([
        'daily_budget_type',
        'daily_budget',
      ]),
    },
  };

  const form_fields = {
    base_form: {
      config: {
        campaign_name: {
          props: {
            disabled: true,
          },
          rules: {
            require: false,
          },
        },
      },
    },
    budget_and_bid_form: {
      config: {
        price_type: {
          label: '出价方式',
          type: 'label',
          hidden: true,
          value: '',
        },
        price_strategy: {
          label: '出价策略',
          type: 'label',
          hidden: true,
          value: '',
        },
        convert_goal: {
          label: '优化目标',
          type: 'label',
          hidden: true,
          value: '',
        },
        deep_convert_goal: {
          label: '深度优化目标',
          type: 'label',
          hidden: true,
          value: '',
        },
        deep_bid_type: {
          label: '深度优化方式',
          type: 'label',
          hidden: true,
          value: '',
        },
        budget_optimize_switch: {
          label: '预算择优分配',
          type: 'label',
          hidden: true,
          value: '',
        },
        cpa_bid: {
          label: '优化目标出价',
          type: 'input-number',
          hidden: true,
          props: {
            step: 1,
            precision: 2,
            min: 0.01,
            max: 999999999.00,
          },
          formItemTips: {
            props: {
              class: 'inline-block',
              style: {
                marginLeft: '10px',
              },
            },
            content: '元',
          },
          value: undefined,
          rules: { required: true, message: '请输入优化目标出价', trigger: ['change'] },
        },
        roi_goal: {
          label: '深度ROI系数出价',
          type: 'input-number',
          hidden: true,
          props: {
            step: 1,
            precision: 3,
            min: 0.001,
            max: 1000,
          },
          value: undefined,
          rules: { required: true, message: '请输入深度ROI系数出价', trigger: ['change'] },
        },
      },
    },
  };

  return deepMerge([basic_form_fields, form_fields]);
};
